<!-- bilgidialog.vue -->
<!--
  Genel amacli, tekrar kullanilabilir bir bilgilendirme dialogu: baslik +
  kisa bir aciklama metni ve istege bagli olarak altinda bir resim gosterir.
  Ilk kullanim yeri BiziClick aktarim sayfasindaki "Cari Kod gelmiyor, ne
  yapmaliyim?" baglantisidir, ama baslik/mesaj/resim tamamen disaridan prop
  olarak verildigi icin herhangi bir ekranda ayni sekilde kullanilabilir.
-->
<template>
  <v-dialog v-model="acik" max-width="520px" scrollable>
    <v-card>
      <v-toolbar color="primary" dark dense flat>
        <v-toolbar-title>{{ baslik }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click.stop="acik = false" color="white">close</v-icon>
      </v-toolbar>

      <v-card-text class="pt-3">
        <div>{{ mesaj }}</div>

        <v-img
          v-if="resimSrc"
          :src="resimSrc"
          contain
          class="mt-3"
          max-height="500"
        ></v-img>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click.stop="acik = false">{{
          $t("Close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    baslik: { type: String, default: "" },
    mesaj: { type: String, default: "" },
    // require() ile cozulmus bir modul (webpack asset) ya da tam bir URL.
    resimSrc: { type: String, default: null },
  },
  data() {
    return {
      acik: false,
    };
  },
  methods: {
    open() {
      this.acik = true;
    },
  },
};
</script>
